module.exports = __webpack_public_path__ + "img/laptop-cloud.b1e03f10.svg";